import React from 'react';

export default function EncouragementMessage() {
  return (
    <div className="text-center pt-3 px-3 border-t border-border">
      <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
        <q>
          Again, truly I tell you that if two of you on earth agree about anything
          they ask for, it will be done for them by my Father in heaven.
        </q>{' '}
        – Matthew 18:19
      </p>
    </div>
  );
}
